module.exports = __webpack_public_path__ + "img/Arrow_circle_up_solid.b1ec86ec.svg";